import keyMirror from '../../../utils/keyMirror';

export default keyMirror('ccpa', 'gdpr', 'global', 'unknown');
